/* eslint-disable camelcase */
import React, { FC } from 'react';
import {
  USERS_SELECTED,
  DIST_SELECTION_MORE_LIKELY_TO_CONVERT,
  APPROX,
  CONVERSIONS_PREDICTED,
  VIEW_SELECTION_IN_SEGMENTATION,
} from 'modules/predictiveGoals/constants';
import { SegmentationLinkButton } from 'modules/segmentation/navigation/SegmentationLinkButton';
import { CompleteQuery } from 'modules/queryBuilder/types';
import {
  getContactsSelected,
  getConvertRatio,
  getConversionsPredicted,
  transformDataToSlider,
} from './utils/dataHelpers';
import { useGoalGraphContext } from '../contexts/GoalGraphContext';
import { PredictiveGoalModelDetails } from '../../types';
import { ContactsSelect, ConvertAverage, HistogramDerivedContainer, Predicted } from './Styled';

export type DistributionSelectionDataProps = {
  isSegmentationButtonDisabled: boolean;
  model: Required<PredictiveGoalModelDetails>;
  onSegmentationClick: () => void;
  searchQuery: CompleteQuery;
};

export const DistributionSelectionData: FC<
  React.PropsWithChildren<DistributionSelectionDataProps>
> = ({ model, onSegmentationClick, isSegmentationButtonDisabled, searchQuery }) => {
  const {
    distributionData: { range },
  } = useGoalGraphContext();
  const { prob_at_each_percentile, num_users } = model;
  const transformedMin = transformDataToSlider(range.minPoint);
  const transformedMax = transformDataToSlider(range.maxPoint);

  const totalContactsSelected = getContactsSelected(num_users, transformedMin, transformedMax);
  const likelyConvertRatio = getConvertRatio(
    prob_at_each_percentile,
    transformedMin,
    transformedMax,
  );
  const totalConversionsPredicted = getConversionsPredicted(
    num_users,
    prob_at_each_percentile,
    transformedMin,
    transformedMax,
    likelyConvertRatio,
  );

  return (
    <HistogramDerivedContainer>
      <ContactsSelect>{`${totalContactsSelected} ${USERS_SELECTED}`}</ContactsSelect>
      <ConvertAverage>{`${likelyConvertRatio}${DIST_SELECTION_MORE_LIKELY_TO_CONVERT}`}</ConvertAverage>
      <Predicted>{`${APPROX} ${totalConversionsPredicted} ${CONVERSIONS_PREDICTED}`} </Predicted>
      <SegmentationLinkButton
        searchQuery={searchQuery}
        onClick={onSegmentationClick}
        isDisabled={isSegmentationButtonDisabled}
      >
        {VIEW_SELECTION_IN_SEGMENTATION}
      </SegmentationLinkButton>
    </HistogramDerivedContainer>
  );
};
